import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiEmailSequenceRunSummary } from "@/types/integrations/integration.types.ts";
import { ApiCandidate, ApiCandidateShort } from "@/types/recruit/applicant.types";
import {
  ApiCandidateCreatePayload,
  ApiCandidateMassSave,
} from "@/types/recruit/candidate.types.ts";

export const apiCandidates = {
  create: (payload: ApiCandidateCreatePayload) => {
    return api.post<ApiCandidateShort>(`/api/v1/candidates`, payload);
  },
  getByApplicantId: (applicantId: number) => {
    return api.get<ApiCandidate[]>(`/api/v1/candidates/by-applicant/${applicantId}`);
  },
  delete: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/candidates/${id}`);
  },
  snooze: (id: number) => {
    return api.put<ApiOperationResult>(`/api/v1/candidates/${id}/snooze`, {});
  },
  massAction: (payload: ApiCandidateMassSave) => {
    return api.post(`/api/v1/candidates/mass`, payload);
  },

  evaluateScore: (id: number) => {
    return api.post<ApiOperationResult>(`/api/v1/candidates/${id}/evaluate-ai-score`, {});
  },

  updateScore: (id: number, score: number) => {
    return api.post<ApiCandidate>(`/api/v1/candidates/${id}/update-ai-score`, {
      ai_score: score,
    });
  },

  cancelEmailSequenceRun: (runId: number) => {
    return api.put<ApiEmailSequenceRunSummary>(`/api/v1/email-sequence-runs/${runId}/cancel`, {});
  },
};
